<template>
  <router-view></router-view>
</template>

<script>
const COLOR_THEMES = {
  orange: {
    '--sk-primary':           '#d4720a',
    '--sk-primary-dark':      '#8b2500',
    '--sk-primary-darker':    '#1a0a00',
    '--sk-primary-rgb':       '212, 114, 10',
    '--sk-primary-dark-rgb':  '139, 37, 0',
    '--sk-primary-hover':     '#e0800f',
    '--sk-primary-dark-hover':'#a02c00',
    '--sk-primary-light':     '#f5ede0',
    '--sk-input-border':      '#edd9c0',
    '--sk-bg-page':           '#fdf6f0',
    '--sk-table-head-bg':     '#fdf0e0',
    '--sk-table-head-border': '#f5d5a8',
    '--sk-table-row-border':  '#faf0e6',
    '--sk-disabled-color':    '#c4a882',
  },
  blue: {
    '--sk-primary':           '#687cfe',
    '--sk-primary-dark':      '#3a4fbf',
    '--sk-primary-darker':    '#0d1440',
    '--sk-primary-rgb':       '104, 124, 254',
    '--sk-primary-dark-rgb':  '58, 79, 191',
    '--sk-primary-hover':     '#7b8dff',
    '--sk-primary-dark-hover':'#4a60d0',
    '--sk-primary-light':     '#e8ecff',
    '--sk-input-border':      '#d0d6ff',
    '--sk-bg-page':           '#f4f5ff',
    '--sk-table-head-bg':     '#eef0ff',
    '--sk-table-head-border': '#c5caff',
    '--sk-table-row-border':  '#f0f2ff',
    '--sk-disabled-color':    '#9aa0d0',
  },
  green: {
    '--sk-primary':           '#2e7d32',
    '--sk-primary-dark':      '#1b5e20',
    '--sk-primary-darker':    '#0a1f0b',
    '--sk-primary-rgb':       '46, 125, 50',
    '--sk-primary-dark-rgb':  '27, 94, 32',
    '--sk-primary-hover':     '#388e3c',
    '--sk-primary-dark-hover':'#256427',
    '--sk-primary-light':     '#e8f5e9',
    '--sk-input-border':      '#c8e6c9',
    '--sk-bg-page':           '#f1f8f1',
    '--sk-table-head-bg':     '#e8f5e9',
    '--sk-table-head-border': '#a5d6a7',
    '--sk-table-row-border':  '#f1f8f1',
    '--sk-disabled-color':    '#81c784',
  },
  black: {
    '--sk-primary':           '#424242',
    '--sk-primary-dark':      '#212121',
    '--sk-primary-darker':    '#000000',
    '--sk-primary-rgb':       '66, 66, 66',
    '--sk-primary-dark-rgb':  '33, 33, 33',
    '--sk-primary-hover':     '#616161',
    '--sk-primary-dark-hover':'#303030',
    '--sk-primary-light':     '#eeeeee',
    '--sk-input-border':      '#bdbdbd',
    '--sk-bg-page':           '#f5f5f5',
    '--sk-table-head-bg':     '#eeeeee',
    '--sk-table-head-border': '#9e9e9e',
    '--sk-table-row-border':  '#f5f5f5',
    '--sk-disabled-color':    '#9e9e9e',
  },
  red: {
    '--sk-primary':           '#c62828',
    '--sk-primary-dark':      '#7f0000',
    '--sk-primary-darker':    '#3e0000',
    '--sk-primary-rgb':       '198, 40, 40',
    '--sk-primary-dark-rgb':  '127, 0, 0',
    '--sk-primary-hover':     '#d32f2f',
    '--sk-primary-dark-hover':'#9a0000',
    '--sk-primary-light':     '#ffebee',
    '--sk-input-border':      '#ffcdd2',
    '--sk-bg-page':           '#fff5f5',
    '--sk-table-head-bg':     '#ffebee',
    '--sk-table-head-border': '#ef9a9a',
    '--sk-table-row-border':  '#fff5f5',
    '--sk-disabled-color':    '#ef9a9a',
  },
  yellow: {
    '--sk-primary':           '#f9a825',
    '--sk-primary-dark':      '#e65100',
    '--sk-primary-darker':    '#bf360c',
    '--sk-primary-rgb':       '249, 168, 37',
    '--sk-primary-dark-rgb':  '230, 81, 0',
    '--sk-primary-hover':     '#fbc02d',
    '--sk-primary-dark-hover':'#f57c00',
    '--sk-primary-light':     '#fff8e1',
    '--sk-input-border':      '#ffe082',
    '--sk-bg-page':           '#fffdf0',
    '--sk-table-head-bg':     '#fff8e1',
    '--sk-table-head-border': '#ffe082',
    '--sk-table-row-border':  '#fffdf0',
    '--sk-disabled-color':    '#ffd54f',
  },
};

export function applyColorTheme(theme) {
  const vars = COLOR_THEMES[theme] || COLOR_THEMES.orange;
  const root = document.documentElement;
  Object.entries(vars).forEach(([key, val]) => root.style.setProperty(key, val));
  root.style.setProperty('--vz-primary', vars['--sk-primary']);
  root.style.setProperty('--vz-primary-rgb', vars['--sk-primary-rgb']);
}

export default {
  name: 'App',
  created() {
    applyColorTheme(localStorage.getItem('colorTheme') || 'orange');
  },
};
</script>
